export default "__VITE_ASSET__Dc97takc__"